<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
      <div class="container-post">
        <div class="form-modal">
            <!-- <h2>Add New Data</h2> -->
            <button  class="close" @click="back()"></button>
            <div class="mg-top1">
              <p>Banner</p>
              <input id="assetUpload" type="file" accept="image/*" @change="onAddFile($event)" hidden> 
              <div class="mg-top1">
                  <img class="imgUpload" v-if="assetImgUrl" :src="assetImgUrl" alt="">
                  <button class="btn-upload mg-top1 mg-right" @click="chooseFiles()">Choose</button>
              </div>
            </div>
            <div class="wrapper">
              <div class="input-data mg-top">
                <select class="select-css" name="" id="" v-model="dpw_id">
                  <option value="" disabled selected>Select Dpw :</option>
                  <option v-for="(data, index) in listDpw" :key="index" :value="data.dpw_id">{{ data.dpw_name }}</option>
                </select>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="name">
                <div class="underline"></div>
                <label>Name</label>
              </div>
              <div class="text-area mg-top">
                <textarea name="" id="" required v-model="description"></textarea>
                <div class="underline"></div>
                <label>Description</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="ketua">
                <div class="underline"></div>
                <label>Ketua</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="sekretaris">
                <div class="underline"></div>
                <label>Sekretaris</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="bendahara">
                <div class="underline"></div>
                <label>Bendahara</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="email">
                <div class="underline"></div>
                <label>Email</label>
              </div>
              <div class="input-data mg-top">
                  <input type="text" required v-model="website">
                  <div class="underline"></div>
                  <label>Website</label>
              </div>
              <div class="text-area mg-top">
                  <textarea name="" id="" required v-model="alamat"></textarea>
                  <div class="underline"></div>
                  <label>Alamat</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="latitude">
                <div class="underline"></div>
                <label>Latitude</label>
              </div>
              <div class="input-data mg-top">
                <input type="text" required v-model="longitude">
                <div class="underline"></div>
                <label>Longitude</label>
              </div>
              <div class="btn-heading">
                <p class="mg-top" v-if="errors.length">
                    <b>Please correct the following error(s):</b>
                    <ul>
                        <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                    </ul>
                </p>

                <button class="btn-add mg-top1" @click="validation(id != 0 ? 'update' : 'add')">
                    {{ id != 0? 'Update' : 'Add'}} DPD
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';

import auth from '@/service/auth.js'

export default {
  name: 'DPDForm',
  data () {
    return {
      order_id: '',
      id:'',
      dpw_id:'',
      assetImage: null,
      assetImgUrl : null,
      name: '',
      description: '',
      ketua: '',
      sekretaris: '',
      bendahara: '',
      alamat: '',
      email: '',
      website: '',
      latitude: '',
      longitude: '',
      listDpw: [],
      isLoading: false,
      errors: [],
      limitDpw: 1000
    }
  },
  methods: {
     validation(type) {
      this.errors = []

      if (type === 'add') {
        if (!this.name) this.errors.push('* Name cannot be empty')
        if (!this.ketua) this.errors.push('* Ketua Name required')
        if (!this.sekretaris) this.errors.push('* Sekretaris Name required')
        if (!this.bendahara) this.errors.push('* Bendahara Name required')
        if (!this.alamat) this.errors.push('* Enter valid address')
        if (!this.latitude) this.errors.push('* Enter valid latitude')
        if (!this.longitude) this.errors.push('* Enter valid longtitude')
      }  
        

      if (this.errors.length > 0) {
          return
      } else if (type === 'add') {
          this.addDPD()
      } else if (type === 'update') {
          this.updateDPD()
      }
    },
    uploadImage () {
      this.image = file.dataURL
    },
    onAddFile (e) {
        console.log(e)
        this.assetImage = e.target.files[0]
        this.assetImgUrl = URL.createObjectURL(this.assetImage)
        console.log('asset', this.assetImage)
        console.log('assetUrl', this.assetImgUrl)
    },
    chooseFiles() {
        document.getElementById("assetUpload").click()
    },
    async getListDpw() {
      this.isLoading = true
      try {
          const response = await axios.get('/member/listdpw', {
            params: {
              limit: this.limitDpw
            }
          })
          console.log(response)

          this.listDpw = response.data.data
          console.log('dataProvinsi', this.listDpw)
          this.isLoading = false
      } catch (error) {
          console.log(error)
      }
    },
    getDataById () {
      let dataById = localStorage.getItem('dataPerindoById')
      console.log('localS' , dataById)
            
      let data = JSON.parse(dataById)

      this.assetImage = data.dpd_foto.String
      this.assetImgUrl = data.dpd_foto.String
      this.dpw_id = data.dpw_id
      this.name = data.dpd_name
      this.ketua = data.dpd_ketua
      this.sekretaris = data.dpd_sekretaris
      this.bendahara = data.dpd_bendahara
      this.email = data.dpd_email.String
      this.website = data.dpd_website.String
      this.alamat = data.dpd_alamat
      this.latitude = data.dpd_latitude
      this.longitude = data.dpd_longitude
    },
    async addDPD () {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        try {
          this.isLoading = true
          const formData = new FormData()
          
          // let date = moment(this.date).format()
  
          formData.append('dpd_foto', this.assetImage)
          formData.append('dpw_id', this.dpw_id)
          formData.append('dpd_name', this.name)
          formData.append('dpd_description', this.description)
          formData.append('dpd_ketua', this.ketua)
          formData.append('dpd_sekretaris', this.sekretaris)
          formData.append('dpd_bendahara', this.bendahara)
          formData.append('dpd_email', this.email)
          formData.append('dpd_website', this.website)
          formData.append('dpd_alamat', this.alamat)
          formData.append('dpd_latitude', this.latitude)
          formData.append('dpd_longitude', this.longitude)
  
          const response = await axios.post('/member/dpd', formData)
          this.isLoading = false
  
          console.log(response)
          if(response.status == 201) {
              alert.success('Add data success', () => this.$router.go(-1))
          }
        } catch (error) {
            console.log(error)
            alert.failed('Add data failed')
        }
      }
    },
    async updateDPD () {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        try {
          this.isLoading = true
          const formData = new FormData()
          
          // let date = moment(this.date).format()
  
          formData.append('dpd_foto', this.assetImage)
          formData.append('dpw_id', this.dpw_id)
          formData.append('dpd_name', this.name)
          formData.append('dpd_description', this.description)
          formData.append('dpd_ketua', this.ketua)
          formData.append('dpd_sekretaris', this.sekretaris)
          formData.append('dpd_bendahara', this.bendahara)
          formData.append('dpd_email', this.email)
          formData.append('dpd_website', this.website)
          formData.append('dpd_alamat', this.alamat)
          formData.append('dpd_latitude', this.latitude)
          formData.append('dpd_longitude', this.longitude)
  
          const response = await axios.patch(`/member/dpd/${this.id}`, formData)
          this.isLoading = false
  
          console.log(response)
          if(response.status == 200) {
              alert.success('Update data success', () => this.$router.go(-1))
          }
        } catch (error) {
            console.log(error)
            alert.failed('Update data failed')
        }
      }
    },
    back () {
      this.$router.go(-1)
    },
  },
  components: {
    Loader
  },
  created() {
    this.id = this.$route.params.id
    if (this.id != 0) {
      this.getDataById()
    }
    this.getListDpw()
  }
}
</script>